/* eslint-disable react/no-array-index-key */
import React, { Fragment } from 'react';
import Oferta from './oferta';
import Prealoader from '../layout/Preloader';
import NoResultados from '../layout/no-resultados';
import '../paquetes-lista/contenido.css';

const contenidoOferta = (props) => {
  const { ofertas, preloader } = props;

  if (preloader) return <Prealoader titulo='Buscando sus ofertas...' />;

  if (ofertas.length === 0) return <NoResultados />;

  return (
    <>
      {ofertas.map((elemento, index) => {
        //const HOC = index > 20 ? "Fragment" : "LazyLoad";
        return (
          <Oferta
            key={index}
            oferta={elemento}
            indice={index}
          />
        );

      })}
    </>
  );
};

export default contenidoOferta;
